import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SEU_ENVIRONMENT } from '@seu-environment';
import { cloneDeep } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { SEU_MOCK_CALC_RESPONSE } from '../mock/calc-response.mock';
import { SEU_MOCK_COMPUTATION_COMBINATIONS } from '../mock/computation-combinations.mock';
import { SEU_FALLBACK_CONFIG } from '../mock/config.mock';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor() {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const useMockdata = SEU_ENVIRONMENT.mock;

    if (useMockdata) {
      // if (request.url.includes('/offers') && request.method === 'POST') {
      //   return throwError(
      //     () =>
      //       new HttpErrorResponse({
      //         status: 409,
      //         statusText: 'Offer with this number already exists',
      //         error: null,
      //       })
      //   );
      // }
      if (request.url.includes('/offerComputations/offers/')) {
        return of(
          new HttpResponse({
            status: 200,
            body: cloneDeep(SEU_MOCK_CALC_RESPONSE),
          })
        );
      }

      if (request.url.endsWith('/setup')) {
        return of(
          new HttpResponse({
            status: 200,
            body: cloneDeep(SEU_FALLBACK_CONFIG),
          })
        );
      }

      // computationCombinations
      if (
        request.url.endsWith('/computationCombinations') &&
        request.method === 'GET'
      ) {
        return of(
          new HttpResponse({
            status: 200,
            body: cloneDeep(SEU_MOCK_COMPUTATION_COMBINATIONS),
          })
        );
      }

      // if (request.url.match(/\/offers\/[0-9a-zA-Z]+$/)) {
      //   return of(
      //     new HttpResponse({
      //       status: 200,
      //       body: cloneDeep(SEU_MOCK_OFFER_DETAIL),
      //     })
      //   );
      // }
    }

    return next.handle(request);
  }
}
